<template>
  <div class="device_control_page_wraper">
    <div v-show="userControlData.openState === 0" class="device_control_page_background_wraper"
      :class="userControlData.openState === 0 ? 'fade_in_public' : 'fade_out_public'"></div>
    <div class="close_img_top public_z_index6">
      <img src="~assets/img/controlpublic/control-guanbi-chahao.png" @click="$closeControlToast" alt />
    </div>
    <div class="devce_name public_z_index6 z_ellipsis1">{{ objData.remark }}</div>

    <div class="device020_content_wraper">
      <div v-for="(value, index) in objData.dtList" :key="index" class="device020_btn_wraper z_ellipsis1"
        :class="showShuXianFlangHandle(index) ? 'device020_btn_left_wraper' : 'device020_btn_right_wraper'"
        @click="mianBanBtnHandle(objData.dtList[index])">
        <span class="device020_yuandian"></span>
        <span class="device020_text">{{ objData.dtList[index].remark }}</span>
        <div v-show="showShuXianFlangHandle(index)" class="device020_shuxian"></div>
      </div>
    </div>
  </div>
</template>

<script>
/** 
 * 需要注意的是  面板的展示数据和控制参数数据 均在 dtList 这个字段的数组里 对应的数据用处 如下 
  "deleteState": 1,    ///
  "deviceId": "343835797495091200",   ///设备ID请求服务器接口时用到
  "deviceName": "按键1的参数",
  "remark": "主卧窗帘开关"  ///对象名称   页面显示用

  控制接口请求跟其他设备一致
  */

import {
  controlBtnRequestHandle,
  controlMianBanBtnRequestHandle
} from "components/content/control-toast/control-toast-classify/device-public-js";

import ControlSwitchBtn from "components/common/control-switch-btn/control-switch-btn";
import TempSet from "components/common/tempset/temp-set";
import WindSpeed from "components/common/wind-speed/wind-speed";
import AirMode from "components/common/air-mode/air-mode";
export default {
  data() {
    return {
      userControlData: {
        openState: this.objData.openState, ///无用
        openStateValue: this.objData.openStateValue, //无用
        openStateValue1: this.objData.openStateValue1, ///无用
        openStateValue2: this.objData.openStateValue2 ///无用
      }
    };
  },
  props: {
    objData: Object, ///要控制设备的数据
    deviceTemp: {
      ///要显示的当前温度
      default: "--"
    }
  },
  watch: {},
  components: {
    ControlSwitchBtn,
    TempSet,
    WindSpeed,
    AirMode
  },
  methods: {
    showShuXianFlangHandle(index) {
      if (index === 0 || index % 2 === 0) {
        return true;
      } else {
        return false;
      }
    },
    mianBanBtnHandle(mianBanData) {
      console.log(mianBanData);
      controlMianBanBtnRequestHandle(mianBanData); ////面板按键控制的公用方法
    }
  },
  computed: {}
};
</script>

<style>
.device020_content_wraper {
  width: 100%;
  height: 100%;
  /* 超出高度时显示垂直滚动条 */
  overflow-y: auto;
  /* 如果你想禁止水平滚动，且避免内容溢出，可以加 */
  overflow-x: hidden;

  /* 隐藏滚动条（webkit浏览器：Chrome、Edge、Safari） */
  scrollbar-width: none;
  /* Firefox */
  -ms-overflow-style: none;
  /* IE/Edge */
}

.device020_content_wraper::-webkit-scrollbar {
  display: none;
  /* Chrome/Edge/Safari */
}

.device020_btn_wraper {
  height: 50px;
  line-height: 50px;
  background-color: #555555;
  border-radius: 4px;
  margin: 20px 0px 0px 0px;

  display: inline-block;
  width: 150px;

  position: relative;
}

.device020_btn_left_wraper {
  border-radius: 4px 0 0 4px;
}

.device020_btn_right_wraper {
  border-radius: 0 4px 4px 0;
}

.device020_btn_left_wraper:active {
  background-color: #444444;
  border-radius: 4px 0 0 4px;
}

.device020_btn_right_wraper:active {
  background-color: #444444;
  border-radius: 0 4px 4px 0;
}

.device020_yuandian {
  display: inline-block;
  height: 9px;
  width: 9px;
  border-radius: 50%;
  background-color: #f7b500;
  margin-left: 20px;
  margin-right: 10px;
  margin-bottom: 1px;
}

.device020_shuxian {
  width: 1px;
  height: 30px;
  background-color: #999999;

  position: absolute;
  top: 9px;
  right: 0px;
}
</style>
